import useLocalStorage from './useLocalStorage';

export { useLocalStorage };
